module.exports = __webpack_public_path__ + "images/檀程长图_04.jpg?v=f68c12b5";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_04.jpg
 ** module id = 190
 ** module chunks = 1 2
 **/